import { sectionLabels } from "../section-labels";
import { colorFields } from "./_shared";
/**
 * Announcement bar — the thin bar pinned above the header that scrolls/rotates
 * store highlights (free shipping, COD, …). Previously these lived inside the
 * `header` section (its `announcement` blocks + `announcementVariant` setting);
 * they're now their own section so the seller can manage the bar independently
 * with the same on-canvas experience (variant, add/edit/delete lines).
 *
 * Rendered as chrome above the header (by `BuyerShell`), not in the page flow,
 * so its position in the section list doesn't change where it appears.
 */
export const announcementBarSchema = {
    type: "announcement-bar",
    name: sectionLabels["announcement-bar"],
    description: {
        ar: "الشريط الرفيع فوق الشريط العلوي اللي بيعرض رسائل المتجر (شحن مجاني، دفع عند الاستلام…).",
        en: "The thin bar above the header that scrolls store messages (free shipping, COD…).",
    },
    availableOnTemplates: ["home"],
    maxPerTemplate: 1,
    settings: [
        {
            id: "variant",
            type: "select",
            ui: "thumbnail",
            label: { ar: "نوع الشريط", en: "Bar style" },
            helpText: {
                ar: "طريقة عرض رسائل شريط الإعلان.",
                en: "How the announcement messages are displayed.",
            },
            options: [
                { value: "ann-marquee", label: { ar: "متحرك", en: "Marquee" } },
                {
                    value: "ann-sparkle",
                    label: { ar: "متحرك بنجمة ✦", en: "Sparkle marquee (✦)" },
                },
                { value: "ann-static", label: { ar: "ثابت", en: "Static" } },
                { value: "ann-rotate", label: { ar: "متبدّل", en: "Rotating" } },
                { value: "ann-ticker", label: { ar: "شريط أخبار", en: "Ticker" } },
                { value: "ann-split", label: { ar: "طرفان", en: "Split" } },
                {
                    value: "ann-store",
                    label: { ar: "متجر (سوشيال + رسالة + سياسات)", en: "Store (social + message + policies)" },
                },
                {
                    value: "ann-ring",
                    label: {
                        ar: "سوشيال بإطار (أيقونات مربعة + عنوان + سياسات)",
                        en: "Social boxed (boxed social + bold headline + policies)",
                    },
                },
            ],
            default: "ann-marquee",
        },
        {
            // Default ON: a store with no active automatic promotion produces no
            // lines, so switching this on changes nothing until there is a real
            // offer to announce. A seller who wants the bar to carry only their own
            // wording unchecks it.
            id: "showLiveOffers",
            type: "checkbox",
            label: { ar: "اعرض عروض المتجر الحالية", en: "Show the store's live offers" },
            helpText: {
                ar: "لما يكون عندك عروض تلقائية شغالة (شحن مجاني، خصومات) الشريط بيعرضها بدل رسايلك، وبيرجّع رسايلك أول ما العرض يخلص. العروض اللي بكود مش بتظهر هنا.",
                en: "While an automatic promotion is running (free shipping, discounts) the bar announces it INSTEAD of your own messages, and your messages return when it ends. Code coupons are never advertised here.",
            },
            default: true,
        },
        ...colorFields(),
    ],
    blocks: [
        {
            type: "announcement",
            name: { ar: "رسالة شريط الإعلان", en: "Announcement" },
            description: {
                ar: "سطر واحد يظهر في الشريط اللي فوق خالص.",
                en: "A single line shown in the bar above the header.",
            },
            maxPerSection: 6,
            settings: [
                {
                    id: "text",
                    type: "text",
                    i18n: true,
                    label: { ar: "النص", en: "Text" },
                    validate: { max: 80, required: true },
                },
            ],
        },
    ],
};
//# sourceMappingURL=announcement-bar.js.map